module.exports = __webpack_public_path__ + "assets/029ccd22a2e79bb9d0c17e5870deea57.mp4";